// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"8755fa9e","977":"fc94fac3"}[chunkId] + ".chunk.js";
};